import React, { Component } from "react";
import { Button } from "../ui";
import i18n from "../../../Utils/i18next";
import {
    PlusOutlined,
    EditOutlined,
} from "@ant-design/icons";
import "./DashboardVariableTable.css";

// activeValues prop olarak alınacak

export default class DashboardVariableTable extends Component {
    renderHeader = () => {
        if (!this.props.variables || this.props.variables.length === 0) {
            return null;
        }

        return (
            <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 10 }}>
                <Button
                    type="primary"
                    onClick={this.props.onAdd}
                    icon={<PlusOutlined />}
                    size="small"
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "4px",
                        paddingBottom: "2px"
                    }}
                >
                    {i18n.t("Add")}
                </Button>
            </div>
        );
    };

    render() {
        const { activeValues = new Map(), variables = [] } = this.props;

        return (
            <div className="dashboard-variable-compact-list">
                {this.renderHeader()}
                <div className="dashboard-variable-list-wrapper">
                    {variables.length === 0 ? (
                        <div style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "100%",
                            height: "100%",
                            minHeight: "250px",
                            backgroundColor: "#fafafa",
                            borderRadius: "8px",
                            border: "1px solid #f0f0f0"
                        }}>
                            <div style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                gap: "12px"
                            }}>                                
                                <div style={{ textAlign: "center" }}>
                                    <h4 style={{ 
                                        fontSize: 14, 
                                        fontWeight: 500, 
                                        color: "#595959", 
                                        margin: 0 
                                    }}>
                                        {i18n.t("DashboardVariables.NoDashboardVariablesYetTitle")}
                                    </h4>
                                    <p style={{ 
                                        fontSize: 12, 
                                        color: "#8c8c8c", 
                                        margin: "4px 0 16px 0" 
                                    }}>
                                        {i18n.t("DashboardVariables.NoDashboardVariablesYetMessage")}
                                    </p>
                                </div>

                                <Button
                                    type="primary"
                                    icon={<PlusOutlined />}
                                    onClick={this.props.onAdd}
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        gap: "4px"
                                    }}
                                >
                                    {i18n.t("Add")}
                                </Button>
                            </div>
                        </div>
                    ) : (
                        variables.map((v) => {
                            let activeValue = v.defaultValue;

                            if (activeValues.has(v.id)) {
                                activeValue = activeValues.get(v.id);

                                if (activeValue !== null && activeValue !== undefined) {
                                    if (Array.isArray(activeValue)) {
                                        activeValue = activeValue.join(", ");
                                    } else {
                                        activeValue = String(activeValue);
                                    }
                                }
                            }

                            return (
                                <div className="dashboard-variable-card" key={v.id}>
                                    <div className="dashboard-variable-card-row">
                                        <div className="dashboard-variable-card-name">
                                            <span className="dashboard-variable-card-name-text">{v.name}</span>
                                        </div>
                                        <div className="dashboard-variable-card-fields">
                                            <div className="dashboard-variable-card-field">
                                                <div className="dashboard-variable-card-field-label">
                                                    {i18n.t("DashboardVariables.DataType")}
                                                </div>
                                                <div className="dashboard-variable-card-field-value">
                                                    {i18n.t(`DashboardVariables.DataTypes.${(v.dataType || "text").charAt(0).toUpperCase() + (v.dataType || "text").slice(1)}`)}
                                                </div>
                                            </div>
                                            <div className="dashboard-variable-card-field">
                                                <div className="dashboard-variable-card-field-label">
                                                    {i18n.t("DashboardVariables.ActiveValue")}
                                                </div>
                                                <div className="dashboard-variable-card-field-value">
                                                    {activeValue}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="dashboard-variable-card-actions">
                                            <Button
                                                onClick={() => this.props.onEdit(v)}
                                                ghost
                                                type="primary"
                                                icon={<EditOutlined />}
                                                size="small"
                                                shape="circle"
                                            />
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    )}
                </div>
            </div>
        );
    }
}